import Vue from 'vue'
import Router from 'vue-router'

// 导入超时检查工具
import { checkTimeout, doLogout } from "@/utils/autoLogout";

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/',
            name: 'Login',
            component: () =>
                import ('@/components/Login/login'),
            meta: {
                name: "全局"
            }
        },
        {
            path: '/home',
            name: 'Home',
            component: () =>
                import ('@/components/Home/home'),
            meta: {
                name: "全局"
            },
            children: [{
                    path: '/manufacturer',
                    name: 'Manufacturer',
                    component: () =>
                        import ('@/components/accountnumber/manufacturer'), //商场账号
                    meta: {
                        name: "厂商管理",
                    }
                },
                {
                    path: '/addmanufacturer',
                    name: 'Addmanufacturer',
                    component: () =>
                        import ('@/components/accountnumber/addmanufacturer'), //添加厂商账号
                    meta: {
                        name: "厂商管理"
                    }
                },
                {
                    path: '/addduanxin',
                    name: 'Addduanxin',
                    component: () =>
                        import ('@/components/accountnumber/addduanxin'), //短信充值
                    meta: {
                        name: "厂商管理"
                    }
                },
                {
                    path: '/addmoeny',
                    name: 'Addmoeny',
                    component: () =>
                        import ('@/components/accountnumber/addmoeny'), //充值金额
                    meta: {
                        name: "厂商管理"
                    }
                },
                {
                    path: '/details',
                    name: 'Details',
                    component: () =>
                        import ('@/components/accountnumber/details'), //详情
                    meta: {
                        name: "厂商管理"
                    }
                },
                {
                    path: '/editmanufacturer',
                    name: 'Editmanufacturer',
                    component: () =>
                        import ('@/components/accountnumber/editmanufacturer'), //修改厂商
                    meta: {
                        name: "厂商管理"
                    }
                },
                {
                    path: '/role',
                    name: 'Role',
                    component: () =>
                        import ('@/components/accountnumber/role'), //商家角色权限
                    meta: {
                        name: "厂商管理"
                    }
                },
                {
                    path: '/addrole',
                    name: 'Addrole',
                    component: () =>
                        import ('@/components/accountnumber/addrole'), //角色权限-添加角色
                    meta: {
                        name: "厂商管理"
                    }
                },
                {
                    path: '/editrole',
                    name: 'Editrole',
                    component: () =>
                        import ('@/components/accountnumber/editrole'), //角色权限-修改角色
                    meta: {
                        name: "厂商管理"
                    }
                },
                {
                    path: '/message',
                    name: 'Message',
                    component: () =>
                        import ('@/components/message/message'), //短信规则
                    meta: {
                        name: "短信管理"
                    }
                },
                {
                    path: '/recharge',
                    name: 'Recharge',
                    component: () =>
                        import ('@/components/rechargewithdrawal/recharge'), //充值购买记录
                    meta: {
                        name: "费用管理"
                    }
                },
                {
                    path: '/withdrawal',
                    name: 'Withdrawal',
                    component: () =>
                        import ('@/components/rechargewithdrawal/withdrawal'), //提现记录
                    meta: {
                        name: "费用管理"
                    }
                },
                {
                    path: '/code',
                    name: 'Code',
                    component: () =>
                        import ('@/components/code/code'), //码管理
                    meta: {
                        name: "码管理",
                    }
                },
                {
                    path: '/addcode',
                    name: 'Addcode',
                    component: () =>
                        import ('@/components/code/addcode'), //生成码
                    meta: {
                        name: "码管理",
                    }
                },
                {
                    path: '/coderule',
                    name: 'Coderule',
                    component: () =>
                        import ('@/components/coderule/coderule'), //码规则管理
                    meta: {
                        name: "码管理",
                    }
                },

                {
                    path: '/addcoderule',
                    name: 'Addcoderule',
                    component: () =>
                        import ('@/components/coderule/addcoderule'), //新增码规则
                    meta: {
                        name: "码管理",
                    }
                },
                {
                    path: '/editcoderule',
                    name: 'Editcoderule',
                    component: () =>
                        import ('@/components/coderule/editcoderule'), //查看申请
                    meta: {
                        name: "码管理",
                    }
                },
                {
                    path: '/applylist',
                    name: 'Applylist',
                    component: () =>
                        import ('@/components/coderule/applylist'), //码申请
                    meta: {
                        name: "码管理",
                    }
                },
                {
                    path: '/addapply',
                    name: 'Addapply',
                    component: () =>
                        import ('@/components/coderule/addapply'), //添加申请
                    meta: {
                        name: "码管理",
                    }
                },
                {
                    path: '/viewapply',
                    name: 'Viewapply',
                    component: () =>
                        import ('@/components/coderule/viewapply'), //查看申请
                    meta: {
                        name: "码管理",
                    }
                },
                
                {
                    path: '/codeqx',
                    name: 'Codeqx',
                    component: () =>
                        import ('@/components/codeqx/codeqx'), //总后台角色权限
                    meta: {
                        name: "系统管理"
                    }
                },
                {
                    path: '/addcodeqx',
                    name: 'Addcodeqx',
                    component: () =>
                        import ('@/components/codeqx/addcodeqx'), //创建角色
                    meta: {
                        name: "系统管理"
                    }
                },
                {
                    path: '/editcodeqx',
                    name: 'Editcodeqx',
                    component: () =>
                        import ('@/components/codeqx/editcodeqx'), //修改角色
                    meta: {
                        name: "系统管理"
                    }
                },
                {
                    path: '/editpassward',
                    name: 'Editpassward',
                    component: () =>
                        import ('@/components/editpassward/editpassward'), //修改个人密码
                    meta: {
                        name: "全局"
                    }
                },
                {
                    path: '/administration',
                    name: 'Administration',
                    component: () =>
                        import ('@/components/administration/administration'), //系统管理账号管理
                    meta: {
                        name: "系统管理"
                    }
                },
                {
                    path: '/addadministration',
                    name: 'Addadministration',
                    component: () =>
                        import ('@/components/administration/addadministration'), //系统管理添加账号管理
                    meta: {
                        name: "系统管理"
                    }
                },
                {
                    path: '/editadministration',
                    name: 'Editadministration',
                    component: () =>
                        import ('@/components/administration/editadministration'), //系统管理添加账号管理
                    meta: {
                        name: "系统管理"
                    }
                },
                {
                    path: '/fwcode',
                    name: 'Fwcode',
                    component: () =>
                        import ('@/components/administration/fwcode'), //系统管理添加账号管理
                    meta: {
                        name: "系统管理"
                    }
                },

            ]
        },
        {
            path: '/error',
            name: 'Error',
            component: () =>
                import ('@/components/error/error'), //没权限
            meta: {
                name: "全局"
            }
        },
        {
            path: '/qrcode',
            name: 'Qrcode',
            component: () =>
                import ('@/components/qrcode'), //没权限
            meta: {
                name: "全局"
            }
        },

    ]
})

// ================== 全局路由守卫：超时自动退出 ==================
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('Token');

  // 如果没有 token，并且不是登录页 → 跳登录
  if (!token) {
    if (to.path === '/' || to.path === '/login') {
      next();
    } else {
      next('/');
    }
    return;
  }

  // 如果已经登录，检查是否超时
  if (to.path !== '/' && to.path !== '/login') {
    if (checkTimeout()) {
      doLogout();
      return;
    }
  }

  next();
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js